import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Priyanka",
    lastName: "Sharma",
    bio: "Backend Developer",
    avatar: "https://i.imgur.com/LFiZIPO.png",
    username: "adarshbalika",
    password: "adarshBalika123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Khushal",
    lastName: "Sharma",
    bio: "Software Maker",
    avatar: "https://i.imgur.com/PyplFKM.png",
    username: "logan1x",
    password: "meNhiBataunga",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Vishal",
    lastName: "Sharma",
    bio: "Sports, love and life",
    avatar: "https://i.imgur.com/AJC5NTL.png",
    username: "adbhutvishal",
    password: "adbhut123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Abdur",
    lastName: "Rashid",
    bio: "Loves to read & sing.",
    avatar: "https://i.imgur.com/A4bj7ws.png",
    username: "rashidur",
    password: "test123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Ashwini",
    lastName: "Pandya",
    bio: "Mandala artist | Teen",
    avatar: "https://i.imgur.com/JUgExmC.png",
    username: "ashp",
    password: "ash123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Sachin",
    lastName: "Sharma",
    bio: "Another GitHub user",
    avatar: "https://i.imgur.com/ahfYZCf.png",
    username: "ailasachin",
    password: "khush123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Pratham",
    lastName: "Agrawal",
    bio: "Innovator | Startups",
    avatar: "https://i.imgur.com/iOYmGSu.png",
    username: "prathamagrawal8",
    password: "pratham123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Mayur",
    lastName: "Jain",
    bio: "Reading Harry potter",
    avatar: "https://i.imgur.com/vwOAN9M.png",
    username: "jainmayur",
    password: "alak123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Sadhana",
    lastName: "Singh",
    bio: "Research",
    avatar: "https://i.imgur.com/SGG4GH4.png",
    username: "sadhana1904",
    password: "khiladi123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
